<template>
  <v-sheet
    elevation="0"
    class="pa-2 mb-2 sheet"
  >
    <div
      v-if="!contrat.isOpenForm && !isDelete"
      class="d-flex justify-space-between"
    >
      <div class="align-self-center">
        <div class="d-flex flex-column">
          <div
            class="d-flex justify-space-between intro secondary--text"
          >
            <div class="d-flex">
              <div class="mr-2">
                {{ contrat.libelle }}
              </div>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <img
                    v-if="contrat.contratAgrial"
                    class="align-self-center mr-2 logo-bag"
                    src="@/assets/icon-bag-ar.svg"
                    v-on="on"
                  >
                </template>
                Contrat Agrial
              </v-tooltip>
            </div>
          </div>
          <div
            v-if="contrat.prixPayeEnEuroParTonne"
            class="texte texte-gris-fonce"
          >
            {{ contrat.poidsEnTonne }} t - {{ contrat.prixPayeEnEuroParTonne | roundNumber(2) }} €/t
          </div>
          <div
            v-else
            class="texte texte-gris-fonce"
          >
            {{ contrat.poidsEnTonne }} t
          </div>
        </div>
      </div>
      <div
        class="d-flex align-self-center"
      >
        <v-btn
          v-if="(contrat.cultures.length > 1 && contrat.contratAgrial) || isSaisieManuelle"
          color="black"
          text
          icon
          @click="onEdit"
        >
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="!contrat.contratAgrial"
          color="black"
          text
          icon
          @click="onDelete"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>
      </div>
    </div>
    <div
      v-else-if="isDelete"
      class="d-flex pa-2"
    >
      <div class="texte texte-gris-fonce">
        Voulez-vous supprimer le contrat ?
      </div>
      <AgrButton
        color="orange"
        :loading="loading.delete"
        elevation="0"
        @click.stop="confirmDeleteContrat"
      >
        <span class="white--text">Oui</span>
      </AgrButton>
      <AgrButton
        class="ml-3"
        color="orange"
        outlined
        :disabled="loading.delete"
        @click.stop="isDelete = false"
      >
        <span>Non</span>
      </AgrButton>
    </div>
    <div
      v-else
      class="pa-3"
    >
      <ContratAdherentForm
        :contrat="contrat"
        :is-from-liste-contrats-global="isFromListeContratsGlobal"
        @reload="reload"
        @closeForm="closeForm"
      />
    </div>
  </v-sheet>
</template>

<script>
import { mapActions } from 'vuex'
import { AgrButton } from '@agrial/ui'
import ContratAdherentForm from './contrat-adherent-form.vue'

export default {
  name: 'ContratAdherent',
  components: { AgrButton, ContratAdherentForm },
  props: {
    contrat: {
      type: Object,
      required: true
    },
    isFromListeContratsGlobal: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isDelete: false,
      loading: {
        delete: false
      }
    }
  },

  computed: {
    isImportation () {
      return this.contrat.typeSaisie === 'IMPORTATION'
    },
    isSaisieManuelle () {
      return this.contrat.typeSaisie === 'SAISIE_MANUELLE'
    }
  },

  methods: {
    ...mapActions({
      deleteContratVente: 'contratVente/deleteContratVente'
    }),
    onEdit () {
      this.$emit('openForm', this.contrat)
    },
    onDelete () {
      this.isDelete = true
    },
    closeForm () {
      this.$emit('closeForm')
    },
    reload () {
      this.$emit('reload')
    },
    confirmDeleteContrat () {
      this.loading.delete = true
      this.deleteContratVente(this.contrat)
        .then(() => {
          this.isDelete = false
          this.$emit('reload')
          this.loading.delete = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.help-card {
  border-radius: 0 !important;
}
.bg-titre {
  background-color: #f1f2f5;
}
.sheet {
  border: 1px solid #f1f2f5;
}
.logo-bag {
  width: 1.5em;
}
.texte-orange-fonce {
  color: var(--orange-dark);
}
</style>
